<template>
  <div class="commission-overview">
    <!-- 顶部筛选条件 -->
    <div class="filter-bar">
      <div class="filter-left">
        <span class="filter-label">时间范围：</span>
        <el-radio-group v-model="timeType" size="small" @change="onTimeTypeChange">
          <el-radio-button :label="0">今日</el-radio-button>
          <el-radio-button :label="1">昨日</el-radio-button>
          <el-radio-button :label="2">近7天</el-radio-button>
          <el-radio-button :label="3">近30天</el-radio-button>
          <el-radio-button :label="4">近半年</el-radio-button>
          <el-radio-button :label="5">近一年</el-radio-button>
        </el-radio-group>
      </div>
      <div class="filter-right">
        <el-button type="primary" size="small" icon="el-icon-refresh" @click="refresh" :loading="loading">刷新数据</el-button>
      </div>
    </div>

    <!-- 经营概览 -->
    <div class="section-title"><i class="el-icon-data-analysis"></i> 佣金经营概览</div>

    <!-- 统计卡片 -->
    <el-row :gutter="16" class="stat-row">
      <el-col :span="6" v-for="card in statCards" :key="card.label">
        <div class="stat-card" :class="card.cls">
          <div class="stat-icon"><i :class="card.icon"></i></div>
          <div class="stat-content">
            <div class="stat-label">{{ card.label }}</div>
            <div class="stat-value">{{ card.value }}</div>
            <div class="stat-sub">{{ card.sub }}</div>
          </div>
        </div>
      </el-col>
    </el-row>

    <!-- 图表和排行榜 -->
    <div class="section-title" style="margin-top:8px"><i class="el-icon-s-data"></i> 趋势与排行</div>
    <el-row :gutter="16" class="chart-row trend-ranking-row">
      <el-col :span="14">
        <div class="chart-card trend-card">
          <div class="chart-header">
            <span class="chart-title"><i class="el-icon-s-data"></i> 佣金趋势（近7天）</span>
            <!-- <el-radio-group v-model="trendType" size="mini" @change="updateTrendChart">
              <el-radio-button label="commission">佣金金额</el-radio-button>
              <el-radio-button label="order">订单数量</el-radio-button>
            </el-radio-group> -->
          </div>
          <div ref="trendChart" class="chart-container"></div>
        </div>
      </el-col>
      <el-col :span="10">
        <div class="chart-card ranking-card">
          <div class="chart-header">
            <span class="chart-title"><i class="el-icon-medal"></i> 渠道佣金排行榜</span>
            <el-tag size="mini" type="warning">TOP 10</el-tag>
          </div>
          <div class="ranking-list">
            <div v-for="(item, index) in channelRanking" :key="index" class="ranking-item">
              <span class="ranking-num" :class="getRankingClass(index)">{{ index + 1 }}</span>
              <span class="ranking-name">{{ item.channelName }}</span>
              <span class="ranking-org">{{ item.organizationName || '-' }}</span>
              <span class="ranking-phone">{{ item.phone | filterMaskPhone }}</span>
              <span class="ranking-value">¥{{ item.commissionAmount | filterMoney }}</span>
              <span class="ranking-count">{{ item.orderCount }}单</span>
            </div>
            <el-empty v-if="channelRanking.length === 0" description="暂无数据" :image-size="80"></el-empty>
          </div>
        </div>
      </el-col>
    </el-row>

    <!-- 佣金分布 -->
    <div class="section-title" style="margin-top:8px"><i class="el-icon-data-analysis"></i> 分布分析</div>
    <el-row :gutter="16" class="distribution-row">
      <el-col :span="12">
        <div class="chart-card">
          <div class="chart-header">
            <span class="chart-title"><i class="el-icon-data-analysis"></i> 订单支付方式分布</span>
          </div>
          <div ref="sourceChart" class="chart-container"></div>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="chart-card">
          <div class="chart-header">
            <span class="chart-title"><i class="el-icon-s-data"></i> 线路佣金分布</span>
          </div>
          <div ref="lineChart" class="chart-container"></div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import * as echarts from 'echarts'

export default {
  name: 'CommissionOverview',
  data() {
    return {
      trendType: 'commission',
      timeType: 0,
      loading: false,
      statistics: {
        orderCount: 0,
        orderAmount: 0,
        commissionAmount: 0,
        supportLineCount: 0
      },
      channelRanking: [],
      trendChart: null,
      sourceChart: null,
      lineDistChart: null
    }
  },
  computed: {
    statCards() {
      return [
        { cls: 'primary', icon: 'el-icon-s-order', label: '渠道订单数', value: this.statistics.orderCount, sub: '累计完成' },
        { cls: 'warning', icon: 'el-icon-money', label: '订单总金额', value: '¥' + this.$options.filters.filterMoney(this.statistics.orderAmount), sub: '累计金额' },
        { cls: 'success', icon: 'el-icon-coin', label: '佣金总额', value: '¥' + this.$options.filters.filterMoney(this.statistics.commissionAmount), sub: '累计佣金' },
        { cls: 'info', icon: 'el-icon-data-line', label: '支持渠道线路', value: this.statistics.supportLineCount + '条', sub: '已配置' },
      ]
    }
  },
  mounted() {
    this.loadStatistics()
    this.loadChannelRanking()
    this.$nextTick(() => {
      this.initTrendChart()
      this.initSourceChart()
      this.initLineDistChart()
    })
    // 监听窗口大小变化，重新调整图表
    this.resizeHandler = this.handleResize.bind(this)
    window.addEventListener('resize', this.resizeHandler)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeHandler)
    if (this.trendChart) this.trendChart.dispose()
    if (this.sourceChart) this.sourceChart.dispose()
    if (this.lineDistChart) this.lineDistChart.dispose()
  },
  methods: {
    onTimeTypeChange(val) {
      this.timeType = val
      this.loadStatistics()
      this.$nextTick(() => {
        this.initTrendChart()
        this.initSourceChart()
        this.initLineDistChart()
      })
    },
    /**
     * 加载统计数据
     * 使用接口：GET /api/v1/channel/statistics
     */
    async loadStatistics() {
      this.loading = true
      try {
        const res = await this.$axios.get('/api/v1/channel/statistics', { timeType: this.timeType })
        if (res && res.code === 1 && res.data) {
          const { orderCount, totalOrderAmount, totalCommissionAmount, supportedLineCount } = res.data
          this.statistics = {
            orderCount: orderCount || 0,
            orderAmount: parseFloat(totalOrderAmount || 0),
            commissionAmount: parseFloat(totalCommissionAmount || 0),
            supportLineCount: supportedLineCount || 0
          }
        }
      } catch (error) {
        console.error('获取统计数据失败:', error)
      } finally {
        this.loading = false
      }
    },
    /**
     * 加载渠道排行榜
     * 使用接口：GET /api/v1/channel/commissionRanking
     * 作者：孙艺
     */
    async loadChannelRanking() {
      try {
        const res = await this.$axios.get('/api/v1/channel/commissionRanking')
        if (res && res.code === 1 && res.data) {
          this.channelRanking = res.data.slice(0, 10)
        }
      } catch (error) {
        console.error('获取渠道排行榜失败:', error)
        this.$message.error('获取渠道排行榜失败')
      }
    },
    /**
     * 初始化趋势图表
     * 作者：孙艺
     */
    async initTrendChart() {
      if (!this.$refs.trendChart) return
      if (this.trendChart) {
        this.trendChart.dispose()
      }
      this.trendChart = echarts.init(this.$refs.trendChart)
      
      try {
        const res = await this.$axios.get('/api/v1/channel/commissionTrend')
        if (!res || res.code !== 1 || !res.data) {
          console.error('获取佣金趋势失败: 接口返回异常', res)
          return
        }
        
        const data = (res.data || []).sort((a, b) => {
          // 按佣金金额倒序排序（金额大的在前），这样图表从左到右显示为从大到小
          const amountA = parseFloat(a.commissionAmount || 0)
          const amountB = parseFloat(b.commissionAmount || 0)
          return amountB - amountA
        })
       
        
        // 格式化日期显示（YYYY-MM-DD -> MM/DD）
        const formatDate = (dateStr) => {
          if (!dateStr) return ''
          const parts = dateStr.split('-')
          if (parts.length === 3) {
            return `${parseInt(parts[1])}/${parseInt(parts[2])}`
          }
          return dateStr
        }
        
        const option = {
          tooltip: {
            trigger: 'axis',
            axisPointer: { type: 'shadow' }
          },
          legend: {
            data: ['订单数', '佣金金额'],
            bottom: 0
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '15%',
            top: '10%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            data: data.map(item => formatDate(item.date)),
            axisLine: { lineStyle: { color: '#E4E7ED' } },
            axisLabel: { color: '#606266' },
            inverse: true // true: 从左到右从大到小显示，false: 从左到右从小到大显示
          },
          yAxis: [
            {
              type: 'value',
              name: '订单数',
              axisLine: { show: false },
              axisTick: { show: false },
              splitLine: { lineStyle: { color: '#E4E7ED', type: 'dashed' } },
              axisLabel: { color: '#606266' }
            },
            {
              type: 'value',
              name: '佣金(元)',
              axisLine: { show: false },
              axisTick: { show: false },
              splitLine: { show: false },
              axisLabel: { color: '#606266' }
            }
          ],
          series: [
            {
              name: '订单数',
              type: 'bar',
              data: data.map(item => item.orderCount || 0),
              itemStyle: { color: '#409EFF', borderRadius: [4, 4, 0, 0] },
              barWidth: '40%'
            },
            {
              name: '佣金金额',
              type: 'line',
              yAxisIndex: 1,
              data: data.map(item => parseFloat(item.commissionAmount || 0)),
              itemStyle: { color: '#67C23A' },
              lineStyle: { width: 2 },
              symbol: 'circle',
              symbolSize: 6
            }
          ]
        }
        this.trendChart.setOption(option)
      } catch (error) {
        console.error('获取佣金趋势失败:', error)
        this.$message.error('获取佣金趋势失败')
      }
    },
    /**
     * 更新趋势图表
     * 作者：孙艺
     */
    updateTrendChart() {
      this.initTrendChart()
    },
    /**
     * 初始化订单支付方式分布图表
     * 使用接口：GET /api/v1/channel/payChannelStatistics
     * 作者：孙艺
     */
    async initSourceChart() {
      if (!this.$refs.sourceChart) return
      if (this.sourceChart) {
        this.sourceChart.dispose()
      }
      this.sourceChart = echarts.init(this.$refs.sourceChart)
      
      try {
        const res = await this.$axios.get('/api/v1/channel/payChannelStatistics')
        if (!res || res.code !== 1 || !res.data) {
          console.error('获取支付方式统计失败: 接口返回异常', res)
          return
        }
        
        const data = res.data || []
        
        // 获取支付方式中文映射
        const paymentChannelMap = this.$const.CHANNEL_PAYMENT_CHANNEL || []
        const getPayChannelLabel = (payChannel) => {
          const option = paymentChannelMap.find(item => item.value === payChannel)
          return option ? option.label : payChannel
        }
        
        const option = {
          tooltip: { trigger: 'item', formatter: '{b}: {c} ({d}%)' },
          legend: { bottom: 0, itemWidth: 10, itemHeight: 10 },
          series: [{
            type: 'pie',
            radius: ['40%', '70%'],
            center: ['50%', '45%'],
            avoidLabelOverlap: false,
            itemStyle: { borderRadius: 4, borderColor: '#fff', borderWidth: 2 },
            label: { show: false },
            emphasis: { label: { show: true, fontSize: 14, fontWeight: 'bold' } },
            data: data.map((item, index) => ({
              value: item.orderCount || 0,
              name: getPayChannelLabel(item.payChannel),
              itemStyle: { color: ['#409EFF', '#67C23A', '#E6A23C', '#F56C6C', '#909399'][index % 5] }
            }))
          }]
        }
        this.sourceChart.setOption(option)
      } catch (error) {
        console.error('获取支付方式统计失败:', error)
        this.$message.error('获取支付方式统计失败')
      }
    },
    /**
     * 初始化线路佣金分布图表
     * 使用接口：GET /api/v1/channel/lineCommissionStatistics
     * 作者：孙艺
     */
    async initLineDistChart() {
      if (!this.$refs.lineChart) return
      if (this.lineDistChart) {
        this.lineDistChart.dispose()
      }
      this.lineDistChart = echarts.init(this.$refs.lineChart)
      
      try {
        const res = await this.$axios.get('/api/v1/channel/lineCommissionStatistics')
        if (!res || res.code !== 1 || !res.data) {
          console.error('获取线路佣金分布失败: 接口返回异常', res)
          return
        }
        
        // 按佣金金额正序排序（金额小的在前）
        const data = (res.data || []).sort((a, b) => {
          const amountA = parseFloat(a.commissionAmount || 0)
          const amountB = parseFloat(b.commissionAmount || 0)
          return amountA - amountB
        })
        
        const option = {
          tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' } },
          grid: { left: '3%', right: '4%', bottom: '3%', top: '10%', containLabel: true },
          xAxis: { type: 'value', axisLine: { show: false }, axisTick: { show: false }, splitLine: { lineStyle: { type: 'dashed' } } },
          yAxis: { 
            type: 'category', 
            data: data.map(item => item.lineName || ''), 
            axisLine: { show: false }, 
            axisTick: { show: false },
            inverse: false // true: 从上到下从大到小显示，false: 从上到下从小到大显示
          },
          series: [{
            type: 'bar',
            data: data.map(item => parseFloat(item.commissionAmount || 0)),
            itemStyle: { color: '#67C23A', borderRadius: [0, 4, 4, 0] },
            barWidth: '60%'
          }]
        }
        this.lineDistChart.setOption(option)
      } catch (error) {
        console.error('获取线路佣金分布失败:', error)
        this.$message.error('获取线路佣金分布失败')
      }
    },
    /**
     * 获取排行榜样式类
     * 作者：孙艺
     */
    getRankingClass(index) {
      if (index === 0) return 'rank-gold'
      if (index === 1) return 'rank-silver'
      if (index === 2) return 'rank-bronze'
      return ''
    },
    /**
     * 窗口大小变化时重新调整图表
     * 作者：孙艺
     */
    handleResize() {
      if (this.trendChart) this.trendChart.resize()
      if (this.sourceChart) this.sourceChart.resize()
      if (this.lineDistChart) this.lineDistChart.resize()
    },
    /**
     * 刷新数据（供父组件调用）
     */
    refresh() {
      this.loadStatistics()
      this.loadChannelRanking()
      this.$nextTick(() => {
        this.initTrendChart()
        this.initSourceChart()
        this.initLineDistChart()
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../channel.less';

.commission-overview {
  padding: 4px 0;
  box-sizing: border-box;
}

// 趋势与排行两列等高
.trend-ranking-row {
  display: flex;
  align-items: stretch;

  /deep/ .el-col {
    display: flex;
    flex-direction: column;
  }

  .trend-card, .ranking-card {
    flex: 1;
    display: flex;
    flex-direction: column;

    .chart-container { height: 375px; }

    .ranking-list {
      flex: 1;
      min-height: 375px;
      max-height: 375px;
      overflow-y: auto;
      padding: 0 16px;
    }
  }
}
</style>

